import { render, staticRenderFns } from "./LanghamTemplate.vue?vue&type=template&id=3f52b40a&"
import script from "./LanghamTemplate.vue?vue&type=script&lang=js&"
export * from "./LanghamTemplate.vue?vue&type=script&lang=js&"
import style0 from "./langham2026.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports